module.exports = __webpack_public_path__ + "img/cultura5.7c09381d.png";